module.exports = __webpack_public_path__ + "img/5.688e142e.png";